

//KC Commented Out Below
/*The closing of the submenus would close the main menu, because of the mouseleave of the submenu would close the submenu, which would result in a shorter main menu and thus making it easier to "mouseleave" the main menu and thus close the menu again. This proved to make navigation harder when we have submenus within a main menu.*/
/*let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});*/


/******************** KC Added ********************/

//Instead of auto opening/closing the submenus, we are only auto opening/closing the top-level menus with mouseover and mouseleave
let items = document.querySelector(".header__inline-menu").querySelectorAll("details-disclosure");

items.forEach(item => {
  item.addEventListener("mouseover", () => {
    let dets = item.querySelector("details");

    dets.addEventListener("mouseleave", () => {
      dets.removeAttribute("open");
    });

    dets.setAttribute("open", true);
    
    dets.querySelector("details").addEventListener("mouseleave", () => {
      dets.removeAttribute("open");
    });

  });
});